<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5c-5.51,0-9.99-4.49-9.99-10c0-5.51,4.48-10,9.99-10s10,4.49,10,10C10.5,798.01,6.01,802.5,0.5,802.5z M0.5,800.5
	c4.43,0,8-3.57,8-8c0-4.43-3.57-8-8-8s-7.99,3.57-7.99,8C-7.5,796.93-3.93,800.5,0.5,800.5z M-2.08,797.91
	c-1.24-0.6-2.22-1.59-2.81-2.79l-0.02-0.04l2.58-2.58l-2.58-2.58c0.6-1.24,1.58-2.22,2.79-2.81l0.04-0.02l2.58,2.58l2.58-2.58
	c1.24,0.6,2.22,1.58,2.81,2.79l0.02,0.04l-2.58,2.58l2.58,2.58c-0.6,1.24-1.58,2.22-2.79,2.81l-0.04,0.02l-2.58-2.58L-2.08,797.91
	L-2.08,797.91z"/>
</svg>

</template>